import React from 'react';

const TypingIndicator = () => (
  <div className="flex space-x-2 p-3 rounded-lg max-w-[100px]">
    <div className="w-3 h-3 theme-typing-indicator rounded-full animate-pulse-scale" style={{ animationDelay: '-0.32s' }}></div>
    <div className="w-3 h-3 theme-typing-indicator rounded-full animate-pulse-scale" style={{ animationDelay: '-0.16s' }}></div>
    <div className="w-3 h-3 theme-typing-indicator rounded-full animate-pulse-scale"></div>
  </div>
);

export default TypingIndicator;